import NavBar from 'components/Common/NavigationBar/NavBar'
import { NewProjectDialog } from 'components/Common/NewProject/CreateProjectDialog'
import { UserFeedbackForm } from 'components/UserFeedback/UserFeedback'
import { DialogManager } from 'features/DialogManager/DialogManager'
import { AppRoutes } from './Routes'

export const AppCore = () => {
  return (
    <div className="app">
      <NavBar />
      <main className="main-app">
        <AppRoutes />
      </main>
      <UserFeedbackForm />
      <NewProjectDialog />
      <DialogManager />
    </div>
  )
}

export default AppCore
